module.exports = __webpack_public_path__ + "static/checkout-bg-6cf37ae4bc19fc12bfd89a959094b897.jpg";